// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"e_Wg","content":"e_Xg","container":"e_Yg"};